import { ModuleWithProviders, NgModule, inject, provideAppInitializer } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { Store, StoreModule } from '@ngrx/store';
import { debugActions } from '@mkp/debug/actions';
import { getFeatureFlagsInitialState, getShouldLockDebug } from '@mkp/debug/models';
import { ENVIRONMENT_PROVIDER } from '@mkp/shared/util-environment';
import * as debugEffects from './debug.effects';
import { debugFeature } from './debug.reducer';

@NgModule({
  imports: [StoreModule.forFeature(debugFeature), EffectsModule.forFeature(debugEffects)],
})
export class DebugStateModule {
  static forRoot(): ModuleWithProviders<DebugStateModule> {
    return {
      ngModule: DebugStateModule,
      providers: [
        provideAppInitializer(() => {
          const store = inject(Store);
          const environment = inject(ENVIRONMENT_PROVIDER);
          store.dispatch(
            debugActions.setEnvironmentDefaults({
              defaultFlags: getFeatureFlagsInitialState(environment),
              isLocked: getShouldLockDebug(environment),
            })
          );
        }),
      ],
    };
  }
}
